export default "__VITE_ASSET__477d9024__"